import { GlobalFooterComponent } from './global-footer/global-footer.component';

export const containers: any = [GlobalFooterComponent];

export * from './global-footer/global-footer.component';
